import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/cascade';
import { Backgrounds } from '@picsart/cascade/colors';

const useStyles = createUseStyles({
  imageFrame: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `${Spacings.s12} ${Spacings.s0}`,
    backgroundColor: 'transparent',
    borderWidth: 0,
  },
  active: {
    backgroundColor: Backgrounds.tint5,
  },
  image: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: Spacings.s6,
    filter: (props => props?.isDarkMode ? 'invert(1)' : 'invert(0)'),
  },
});

export default useStyles;
